import { createContext, useContext } from "react";

export const CartContext = createContext(null);

export const useCartContext = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCartContext must be inside CartProvider");
  return ctx;
};
